var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticStyle: { "margin-bottom": "10px", "text-align": "right" } },
        [
          _vm.$parent.checkPer(["admin", "delivery:cost:edit"])
            ? _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    size: "small",
                    icon: "el-icon-plus",
                  },
                  on: { click: _vm.handleAdd },
                },
                [_vm._v("新增费用")]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: { size: "small", icon: "el-icon-refresh" },
              on: { click: _vm.handleRefresh },
            },
            [_vm._v("刷新")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          staticStyle: { width: "100%" },
          attrs: { data: _vm.feeList, border: "", size: "small" },
        },
        [
          _c("el-table-column", {
            attrs: { label: "操作", width: "160", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.status === 0 &&
                    _vm.$parent.checkPer(["admin", "delivery:cost:edit"])
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.handleEdit(scope.row)
                              },
                            },
                          },
                          [_vm._v("编辑")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    (scope.row.status === 0 || scope.row.status === 10) &&
                    _vm.$parent.checkPer(["admin", "delivery:cost:audit"])
                      ? [
                          _c(
                            "el-button",
                            {
                              staticStyle: { color: "#67C23A" },
                              attrs: { type: "text", size: "small" },
                              on: {
                                click: function ($event) {
                                  return _vm.handleAudit(scope.row, 20)
                                },
                              },
                            },
                            [_vm._v("通过")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              staticStyle: { color: "#F56C6C" },
                              attrs: { type: "text", size: "small" },
                              on: {
                                click: function ($event) {
                                  return _vm.handleAudit(scope.row, 30)
                                },
                              },
                            },
                            [_vm._v("拒绝")]
                          ),
                        ]
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "sendNumber",
              label: "发货单号",
              "min-width": "140",
              align: "center",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "contractNumber",
              label: "合同编号",
              "min-width": "140",
              align: "center",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "project",
              label: "项目",
              "min-width": "100",
              align: "center",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "unitPrice",
              label: "单价",
              "min-width": "100",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", [
                      _vm._v(
                        "¥" + _vm._s((scope.row.unitPrice || 0).toFixed(2))
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "quantity",
              label: "包数",
              "min-width": "80",
              align: "center",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "floor",
              label: "楼层",
              "min-width": "80",
              align: "center",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "area",
              label: "面积",
              "min-width": "100",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", [_vm._v(_vm._s(scope.row.area || 0) + "㎡")]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "subTotal",
              label: "小计",
              "min-width": "100",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", [
                      _vm._v(
                        "¥" + _vm._s((scope.row.subTotal || 0).toFixed(2))
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "status",
              label: "状态",
              "min-width": "100",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.status === 0
                      ? _c(
                          "el-tag",
                          { attrs: { size: "small", type: "info" } },
                          [_vm._v("待审核")]
                        )
                      : scope.row.status === 10
                      ? _c(
                          "el-tag",
                          { attrs: { size: "small", type: "warning" } },
                          [_vm._v("申诉")]
                        )
                      : scope.row.status === 20
                      ? _c(
                          "el-tag",
                          { attrs: { size: "small", type: "success" } },
                          [_vm._v("通过")]
                        )
                      : scope.row.status === 30
                      ? _c(
                          "el-tag",
                          { attrs: { size: "small", type: "danger" } },
                          [_vm._v("拒绝")]
                        )
                      : _c("span", [_vm._v("默认")]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "remark", label: "备注", align: "center" },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.dialogTitle,
            visible: _vm.dialogVisible,
            width: "600px",
            "append-to-body": "",
            "close-on-click-modal": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            close: _vm.handleClose,
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                model: _vm.form,
                rules: _vm.rules,
                "label-width": "100px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "发货单号", prop: "sendNumber" } },
                [_c("span", [_vm._v(_vm._s(_vm.form.sendNumber))])]
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "合同编号", prop: "contractNumber" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { placeholder: "请选择合同编号" },
                      model: {
                        value: _vm.form.contractNumber,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "contractNumber", $$v)
                        },
                        expression: "form.contractNumber",
                      },
                    },
                    _vm._l(_vm.contractList, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: {
                          label: item.contractNo,
                          value: item.contractNo,
                        },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "项目", prop: "project" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { placeholder: "请选择项目" },
                      model: {
                        value: _vm.form.project,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "project", $$v)
                        },
                        expression: "form.project",
                      },
                    },
                    _vm._l(
                      _vm.dict.cms_delivery_cost_list_project,
                      function (item, index) {
                        return _c("el-option", {
                          key: item.id || item.value + index,
                          attrs: { label: item.label, value: item.value },
                        })
                      }
                    ),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "单价", prop: "unitPrice" } },
                        [
                          _c("el-input-number", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              min: 0,
                              precision: 2,
                              placeholder: "请输入单价",
                            },
                            model: {
                              value: _vm.form.unitPrice,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "unitPrice", $$v)
                              },
                              expression: "form.unitPrice",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "包数", prop: "quantity" } },
                        [
                          _c("el-input-number", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              min: 0,
                              precision: 2,
                              placeholder: "请输入包数",
                            },
                            model: {
                              value: _vm.form.quantity,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "quantity", $$v)
                              },
                              expression: "form.quantity",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "楼层", prop: "floor" } },
                        [
                          _c("el-input-number", {
                            staticStyle: { width: "100%" },
                            attrs: { min: 0, placeholder: "请输入楼层" },
                            model: {
                              value: _vm.form.floor,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "floor", $$v)
                              },
                              expression: "form.floor",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "面积", prop: "area" } },
                        [
                          _c("el-input-number", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              min: 0,
                              precision: 2,
                              placeholder: "请输入面积",
                            },
                            model: {
                              value: _vm.form.area,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "area", $$v)
                              },
                              expression: "form.area",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "小计", prop: "subTotal" } },
                        [
                          _c("span", [
                            _vm._v(
                              "¥" + _vm._s((_vm.form.subTotal || 0).toFixed(2))
                            ),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "备注", prop: "remark" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 2,
                      placeholder: "请输入备注",
                    },
                    model: {
                      value: _vm.form.remark,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "remark", $$v)
                      },
                      expression: "form.remark",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.handleClose } }, [
                _vm._v("取 消"),
              ]),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.submitLoading },
                  on: { click: _vm.handleSubmit },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }